import Breadcrumb from "./Breadcrumb";

const Hero = ({
  heading,
  subHeading,
  lastUpdate,
  author
}) => {
  return (
    <div className="theme-background text-white py-20 px-4 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute bottom-0 right-10 w-0 h-0 border-l-[40px] border-r-[40px] border-b-[70px] border-l-transparent border-r-transparent border-b-white opacity-20"></div>

      <div className="absolute right-20 -top-10 w-48 h-48 bg-white rounded-full blur-2xl opacity-50 transform -translate-x-1/2 -translate-y-1/2"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Breadcrumb */}
        <Breadcrumb />

        {/* Hero Content */}
        <div className="space-y-4">
          <h1 className="text-4xl md:text-6xl font-extrabold">{heading}</h1>
          <h2 className="text-2xl md:text-3xl font-semibold text-white/90 pl-0">
            {subHeading}
          </h2>
          <p className="text-lg text-white/80 pl-0">
            Created by <span className="font-medium text-white">{author}</span>
            {lastUpdate && (
              <span className="ml-4 text-sm text-white/60">
                Last updated: {lastUpdate}
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero;
